import React, {Component} from 'react';
import styled from 'styled-components';
import Questionmark from "../common/Questionmark";

const LabelContainer = styled.div`
  width: 160px;
`;

const Label = styled.div`
  font-size: ${p => p.theme.sH4}px;
  font-weight: 600;
  margin-bottom: 5px;
  &:last-child{
    margin-bottom: 0;
  }
`;

const ItemContainer = styled.div`
  flex-grow: 1;
`;

const Microcopy = styled.div`
  font-size: ${p => p.theme.sFontMicro}px;
  color: ${p => p.theme.cMicrocopyText};
  max-width: 100px;
  position: relative;
`;

const IconContainer = styled.div`
  position: absolute;
  left: -22px;
  top: 0;
`;

class FilterItem extends Component {
    render() {
        return (
            <div className={this.props.className}>
                <LabelContainer>
                    <Label>
                        {this.props.label}
                    </Label>
                    {this.props.microcopy ? <Microcopy>
                        <IconContainer><Questionmark/></IconContainer>
                        {this.props.microcopy}
                    </Microcopy> : ''}
                </LabelContainer>
                <ItemContainer>
                    {this.props.item}
                </ItemContainer>
            </div>
        );
    };
}

export default styled(FilterItem)`
  display: flex;
  margin-bottom: 60px;
  &:last-child{
    margin-bottom: 0;
  }
`;